import { StyledSelect, inputCls, textareaCls, labelCls } from "../admin/FormComponents"
import { slugify } from "@/lib/slugify"

export type SeedbedStatus = "active" | "paused" | "archived"

export type SeedbedFormFields = {
  institution_id: string
  name: string
  slug: string
  description: string
  status: SeedbedStatus
  start_date: string
  end_date: string
}

export const EMPTY_SEEDBED_FORM: SeedbedFormFields = {
  institution_id: "",
  name: "",
  slug: "",
  description: "",
  status: "active",
  start_date: "",
  end_date: "",
}

type Institution = { id: string; name: string }

/**
 * Campos de identidad + detalles de un semillero, compartidos entre crear
 * (SeedbedFormPage) y editar (la pestaña "Información" de SeedbedDetailPage)
 * para que ambos flujos sean la misma vista.
 */
export function SeedbedInfoForm({
  form,
  setForm,
  institutions,
  isCreate,
}: {
  form: SeedbedFormFields
  setForm: (updater: (f: SeedbedFormFields) => SeedbedFormFields) => void
  institutions: Institution[]
  isCreate: boolean
}) {
  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
      <div className="space-y-3 rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-white/90">Identidad</h3>
        {isCreate && (
          <div>
            <label className={labelCls}>Organización *</label>
            <StyledSelect
              value={form.institution_id}
              onChange={(e) => setForm((f) => ({ ...f, institution_id: e.target.value }))}
            >
              <option value="">Selecciona organización</option>
              {institutions.map((i) => (
                <option key={i.id} value={i.id}>{i.name}</option>
              ))}
            </StyledSelect>
          </div>
        )}
        <div>
          <label className={labelCls}>Nombre del semillero *</label>
          <input
            required
            autoFocus={isCreate}
            placeholder="Nombre del semillero"
            value={form.name}
            onChange={(e) =>
              setForm((f) => ({ ...f, name: e.target.value, slug: isCreate ? slugify(e.target.value) : f.slug }))
            }
            className={inputCls}
          />
        </div>
        <p className="rounded-lg bg-gray-50 px-4 py-2 text-xs text-gray-500 dark:text-gray-400 dark:bg-gray-800">
          Slug: <span className="font-mono">{form.slug || "—"}</span> (autogenerado, no editable)
        </p>
      </div>

      <div className="space-y-3 rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03] lg:col-span-2">
        <h3 className="text-sm font-semibold text-gray-800 dark:text-white/90">Detalles</h3>
        <textarea
          rows={3}
          placeholder="Descripción del enfoque (opcional)"
          value={form.description}
          onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
          className={textareaCls}
        />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          <div>
            <label className={labelCls}>Estado</label>
            <StyledSelect
              value={form.status}
              onChange={(e) => setForm((f) => ({ ...f, status: e.target.value as SeedbedStatus }))}
            >
              <option value="active">Activo</option>
              <option value="paused">Pausado</option>
              <option value="archived">Archivado</option>
            </StyledSelect>
          </div>
          <div>
            <label className={labelCls}>Fecha inicio</label>
            <input
              type="date"
              value={form.start_date}
              onChange={(e) => setForm((f) => ({ ...f, start_date: e.target.value }))}
              className={inputCls}
            />
          </div>
          <div>
            <label className={labelCls}>Fecha fin (opcional)</label>
            <input
              type="date"
              value={form.end_date}
              onChange={(e) => setForm((f) => ({ ...f, end_date: e.target.value }))}
              className={inputCls}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
